import { Flex } from "@mantine/core";
import { useEffect, useMemo, useRef } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import MedicalStatementHistory from "src/components/pages/Settings/YachtSetUp/MedicalHistory/MedicalStatement/MedicalStatementHistory";
import SaveUsersMedicalStatement from "src/components/pages/Settings/YachtSetUp/MedicalHistory/MedicalStatement/SaveUsersMedicalStatement";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import Logbook from "src/generator/Logbook/Logbook";
import { useGetApi } from "src/hooks";
import { useDispatch } from "src/redux/hooks";
import { resetState, setLogbookData } from "src/redux/slices/generatorSlice";
import { PageContainer } from "src/styled";
import { getYachtId } from "src/utils";
interface Props {
  history?: boolean;
}
const UsersMedStatements = ({ history }: Props) => {
  const dispatch = useDispatch();
  const methods = useForm();
  const pageRef = useRef<any>();
  const { userid, cardid } = useParams();

  const body = useMemo(() => {
    if (history && cardid)
      return {
        request: "view-med-card-history-item",
        body: {
          params: {
            cardid,
          },
        },
      };
    return {
      request: "get-med-card-statement",
      body: {
        params: {
          userid,
          yachtid: getYachtId(),
          cardid,
        },
      },
    };
  }, [userid, cardid, history]);

  const { data, refetch } = useGetApi<any>(body);

  useEffect(() => {
    const medData = data?.data?.card ?? data?.card?.card;
    if (!medData) return;
    dispatch(
      setLogbookData({
        data: { content: { data: { latest: { lbentry: medData } } } },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [data]);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, []);

  return (
    <PageContainer ref={pageRef}>
      <FormProvider {...methods}>
        <Breadcrumbs border={false} key={history as any}>
          {!history && (
            <Flex justify="flex-end" gap={10} w="100%">
              <SaveUsersMedicalStatement refetch={refetch} />
              <MedicalStatementHistory />
            </Flex>
          )}
        </Breadcrumbs>
        <Logbook pageRef={pageRef} />
      </FormProvider>
    </PageContainer>
  );
};
export default UsersMedStatements;
